module.exports = __webpack_public_path__ + "static/animation-memo-paper-0379b0de1e3c933dfb7f6a02d7a54582.png";